import DgTabSelect from './src/main.vue'

// 为组件提供 install 安装方法，供按需引入
DgTabSelect.install = function (Vue) {
  Vue.component(DgTabSelect.name, DgTabSelect)
}
export default DgTabSelect

export { DgTabSelect }